import { useEffect } from 'react';
import type { StepProps } from '../engine/context.ts';
import { TitleBlock } from '../ui/TitleBlock.tsx';
import { asset } from '../engine/assets.ts';
import { CREAM, INK, LINE, SHADOW_CARD } from '../ui/theme.ts';

/** cover: hero photo · headline with **bold** · reassurance chips · CTA. */
export function Cover({ step, content, ctx }: StepProps) {
  useEffect(() => {
    ctx.setCta({ label: content.cta ?? ctx.shared.ui?.continue ?? 'Continue', caption: content.ctaCaption, icon: content.ctaIcon, large: true, onPress: () => ctx.next() });
  }, [step.id, content.cta]);

  const slot = step.asset ?? content.asset;

  return (
    <>
      <TitleBlock label={content.label} title={content.title} highlight={content.highlight} subtitle={content.subtitle} top={16} />

      {slot ? (
        <div style={{ flex: 'none', width: '100%', aspectRatio: '7 / 5', borderRadius: 22, overflow: 'hidden', background: CREAM, boxShadow: SHADOW_CARD }}>
          <img src={asset(slot)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        </div>
      ) : null}

      {content.bullets?.length ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
          {content.bullets.map((b) => (
            <span key={b} style={{ padding: '8px 12px', borderRadius: 999, background: CREAM, border: `1.5px solid ${LINE}`, fontSize: 13, fontWeight: 800, color: INK }}>
              {b}
            </span>
          ))}
        </div>
      ) : null}
    </>
  );
}
